import { CIcon } from '~/icons/types'
export const ciSaleRequest: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M15 13a.5.5 0 0 0-.5.5c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4a.5.5 0 0 0 0-1c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5a.5.5 0 0 0-.5-.5Z'
    },
    {
      d:
        'M22.462 5.81A.5.5 0 0 0 22 5.5h-3.5V2a.5.5 0 0 0-.854-.354L14.05 5.243A8.9 8.9 0 0 0 10.5 4.5c-4.962 0-9 4.038-9 9 0 4.963 4.038 9 9 9 4.963 0 9-4.037 9-9a8.9 8.9 0 0 0-.743-3.55l3.596-3.596a.501.501 0 0 0 .109-.545ZM10.5 21.5c-4.411 0-8-3.589-8-8 0-4.41 3.589-8 8-8 1.044 0 2.049.207 3 .594v3.7l-2.854 2.853a.5.5 0 0 0 .708.707l2.854-2.854h3.699a7.91 7.91 0 0 1 .594 3c-.001 4.411-3.59 8-8.001 8Zm7.473-12.18c-.015.006-.031.005-.046.012a.485.485 0 0 0-.185.168H14.5V6.26a.48.48 0 0 0 .168-.186c.007-.015.006-.03.012-.047l2.82-2.82V6a.5.5 0 0 0 .5.5h2.793l-2.82 2.82Z'
    }
  ],
  name: 'sale-request',
  type: 'thin'
}
